<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <template v-for="attr of tableColumns">
          <el-table-column v-bind="attr"></el-table-column>
        </template>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import RemoteSelect from '@core/components/RemoteSelect.vue'

export default {
  components: {RemoteSelect},
  mixins: [table],
  data () {
    return {
      search: {
        ref_id: this.$route.params.refId || null,
      },
      searchFieldType: {},
      tableColumns: [
        {prop: 'id', label: 'ID', width: '100'},
        {prop: 'title', label: '标题', minWidth: '90'},
        {prop: 'content', label: '通知内容', width: '300', showOverflowTooltip: true},
        {prop: 'admin_info', label: '通知人', minWidth: '90'},
        {prop: 'is_read', label: '读取消息状态', minWidth: '90', formatter: row => _.get(this.readStatusMap, row.is_read, row.is_read)},
        {prop: 'created_at', label: '通知时间', width: '180'},
      ],
      readStatusMap: {
        0: '未读',
        1: '已读',
      },
    }
  },
  computed: {},
  created () {},
  methods: {
    getTableData (params) {
      return request.common('attendanceNotifySentHistoryApi', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/attend-notify/InternAttendanceNotifySentHistoryTable.vue